import { Action } from '@ngrx/store';
import {
    ActionOptionsArgs,
    SynchronisableAction
} from '../../../core/store/actions/base-actions';
import { Transition } from './transition.model';

export const ENTITY = 'transition';
export const SUBMIT = '[Transition] Submit';
export const REHYDRATE = '[Transition] Rehydrate';
export const REMOVE = '[Transition] Remove';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Transition, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<Transition>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly type = REMOVE;
    readonly entity = ENTITY;

    constructor(public payload: Transition, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.actions.ts